import * as actions from './actions'

export const DEFAULT_TAKE = 100

const initState = {
    reports: null,
    report: null,
    comments: null,
    commentsPictures: {},
    isLoadingMore: null,
    skip: 0,
    imagesLoader: false,
    reportSharingHistory: null
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.REPORTS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    reports: action.reports,
                    skip: action.reports?.length
                        ? state.skip + DEFAULT_TAKE
                        : state.skip
                }
            }
        case actions.FETCH_MORE_REPORTS:
            return {
                ...state,
                isLoadingMore: true
            }
        case actions.REPORTS_REQUEST_MORE_SUCCESS:
            return {
                ...state,
                isLoadingMore: false,
                reports: action.reports.length
                    ? [...state.reports, ...action.reports]
                    : [...state.reports],
                skip: action.reports.length
                    ? state.skip + DEFAULT_TAKE
                    : state.skip
            }
        case actions.REPORTS_REQUEST_MORE_ERROR:
            return {
                ...state,
                isLoadingMore: false
            }
        case actions.REPORT_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    report: action.report
                }
            }
        case actions.COMMENT_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    comments: action.comments
                }
            }
        case actions.SET_IMAGES_FOR_COMMENTS:
            return {
                ...state,
                ...{
                    commentsPictures: {
                        ...state.commentsPictures,
                        ...action.images
                    }
                }
            }
        case actions.COMMENT_IMAGES_LOADER:
            return {
                ...state,
                imagesLoader: action.loading
            }
        case actions.REPORT_SHARING_HISTORY_REQUEST:
            return {
                ...state,
                reportSharingHistory: null
            }
        case actions.REPORT_SHARING_HISTORY_REQUEST_SUCCESS:
            return {
                ...state,
                reportSharingHistory: action.reportSharingHistory
            }
        case actions.REPORT_SHARING_HISTORY_REQUEST_ERROR:
            return {
                ...state,
                reportSharingHistory: null
            }
        default:
            return state
    }
}
